import React from 'react';

import { Box, Typography } from '@mui/material';
import FormFooter from 'components/FormComponents/FormFooter';
import FormHeader from 'components/FormComponents/FormHeader';
import Modal from 'components/ModalV2';
import Input from 'components/V2/Input';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';

import classes from './activateModal.module.css';

import { hostawayActivateFormValidationSchema as validationSchema } from '../../../../utils';

const ActivateModal = ({ open, setOpen, onClose, onSubmit }) => {
    const formik = useFormik({
        initialValues: {
            apiKey: '',
            accountId: '',
        },
        validationSchema,
        onSubmit: async (values, { resetForm }) => {
            await onSubmit(values, resetForm);
        },
        enableReinitialize: true,
    });

    const handleClose = () => {
        onClose();
        formik.resetForm();
    };

    const handleTrimmedChange = (event) => {
        const { name, value } = event.target;
        formik.setFieldValue(name, value.trim());
    };

    return (
        <Modal open={open} onClose={() => setOpen(false)} disableBackdropClick={true}>
            <form className={classes.form} onSubmit={formik.handleSubmit}>
                <FormHeader title="Enter Account ID and API Key" handleClose={handleClose} />
                <Box className={classes.inputWrapper}>
                    <Input
                        value={formik.values.accountId}
                        variant="outlined"
                        label="Account ID *"
                        labelClass={classes.inputLabel}
                        type="text"
                        name="accountId"
                        className={classes.inputField}
                        handleChange={handleTrimmedChange}
                        error={formik.touched.accountId && Boolean(formik.errors.accountId)}
                        helperText={formik.touched.accountId && formik.errors.accountId}
                    />
                </Box>
                <Box className={classes.inputWrapper}>
                    <Input
                        value={formik.values.apiKey}
                        variant="outlined"
                        label="API Key *"
                        labelClass={classes.inputLabel}
                        type="text"
                        name="apiKey"
                        className={classes.inputField}
                        handleChange={handleTrimmedChange}
                        error={formik.touched.apiKey && Boolean(formik.errors.apiKey)}
                        helperText={formik.touched.apiKey && formik.errors.apiKey}
                    />
                    <Typography className={classes.helpText}>
                        You can generate a public API secret key for Authenticating.com{' '}
                        <a
                            href="https://dashboard.hostaway.com/v3/marketplace/authenticating-com"
                            target="_blank"
                            rel="noreferrer"
                        >
                            here
                        </a>
                    </Typography>
                </Box>
                <FormFooter secondaryBtnHandler={handleClose} btnText="Submit" />
            </form>
        </Modal>
    );
};

ActivateModal.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
};

export default ActivateModal;
